const sampleData = require("../fixtures/content.json")

// this would be a fetch with real data...
export const years = Object.keys(sampleData.years).sort((a, b) => a === "close" ? -1 : 1).reverse()

export const animationSettings = {
  overlapDuration: 1.5,
  timeScale: 0.6,
}

export const componentSettings = {
  scaleDuration: 2,
  scale: 8,
  opacityDuration: 1,
  opacityOutOffset: 1.5,
  videoOptions: {
    height: "390",
    width: "640",
  },
}

/**
 * Calculates one full component animation duration
 */
export const totalCycle = () => {
  let { scaleDuration, opacityDuration, opacityOutOffset } = componentSettings
  return Math.max(
    scaleDuration,
    opacityDuration * 2 + (opacityOutOffset - opacityDuration)
  )
}

// export const progressSettings = {
//   // needs to be based on number of pieces of content
//   duration:
//     // One half-cycle to first year
//     // # content * (cycle - overlap) per year thereafter
//     //

//     (years.reduce((out, curr) => out + sampleData.years[curr].cards.length, 0) +
//       3 * years.length) *
//       (totalCycle() - animationSettings.overlapDuration) +
//     totalCycle() / 2,
//   // years.length * (totalCycle() - animationSettings.overlapDuration) +
//   // animationSettings.overlapDuration,
// }

/**
 * each year should be 1/10 of the above
 * above = 10 * (2.5 - 1.5) + 1.5 = 10 * 1 + 1.5 = 11.5
 * eachYear = 11.5 / 10 = 1.15s in duration
 * halfway = 0.575, 0.575 + 1.15, 0.575 + 1.15 * 2, etc.
 *
 * Each component should be 2.5 total duration
 * You want the middle of the component to be 1.15 apart - current 1.25, 1.25 + 1, 1.25 + 2, etc.
 * That means each component would need to be 1.15 long, NOT 2.5.
 * The duration between years needs to === duration between components
 * But the total timeline length also needs to be the same
 *
 * I need to shorten the middle length and tack on a front and back to fill in
 */
